import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import { QueryFilters } from '../types';
import { TopDailyMfa } from '../../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';

const END_POINT = '/metric/topDailyMfa';
const LIMIT = 9;

type TopDailyMfaDto = TopDailyMfa;

const convertToTopDailyMfa = (dto: TopDailyMfaDto[]): TopDailyMfa[] => {
    return dto.map((item) => ({
        name: item.name,
        guid: item.guid,
        count: item.count
    }));
};

const fetchTopDailyMfa = async (filters: QueryFilters): Promise<TopDailyMfaDto[]> => {
    const data = await apiGet<TopDailyMfaDto[]>(`${API_BASE_URL}${END_POINT}`, {
        ...buildUniversalMfaQueryParams(filters),
        limit: LIMIT.toString()
    });
    return data;
};

export const useTopDailyMfa = (filters: QueryFilters): UseQueryResult<TopDailyMfa[]> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.topDailyMfa(filters),
        queryFn: () => fetchTopDailyMfa(filters),
        select: convertToTopDailyMfa
    });
};
